import { render, staticRenderFns } from "./Destroy.vue?vue&type=template&id=187ffbcc&scoped=true&"
import script from "./Destroy.vue?vue&type=script&lang=js&"
export * from "./Destroy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ffbcc",
  null
  
)

export default component.exports